export const fetchGauntlets = async (query?: string | null, lastKey?: string | null) => {
  const url = 'https://6399kkay5c.execute-api.us-east-1.amazonaws.com/serverless_lambda_stage/gauntlets';
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify({ query: query?.toLowerCase(), lastKey })
  });
  const body = await response.json();
  return body.data;
};
